import { render } from "./NewManifest.vue?vue&type=template&id=1c4bde0b&scoped=true"
import script from "./NewManifest.vue?vue&type=script&lang=js"
export * from "./NewManifest.vue?vue&type=script&lang=js"

import "./NewManifest.vue?vue&type=style&index=0&id=1c4bde0b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4bde0b"]])

export default __exports__